import { View } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import { PatternBackground } from './Backgrounds';

// Each native-stack scene owns its opaque canvas so pushed screens never
// show the previous screen's content through their background.
export default function AppBackground({ children, style, testID = 'app-background' }) {
    return <View testID={testID} style={[styles.canvas, style]}>
        <PatternBackground />
        {children}
    </View>;
}

export const appScreenLayout = ({ children, options }) => options?.presentation === 'transparentModal'
    ? children : <AppBackground>{children}</AppBackground>;

const styles = StyleSheet.create(({ colors }) => ({
    canvas: { flex: 1, backgroundColor: colors.background },
}));
